export default __webpack_public_path__ + "static/media/RunHorseLight_2_2.b5b693b9.jpg";